import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Link } from 'react-router-dom';
import { TrendingUp, Users, Briefcase, Truck, Building } from 'lucide-react';

export default function ReportsGallery() {
  const reports = [
    {
      id: 'margin-analysis',
      title: 'Analiza Marja & Profit',
      desc: 'Calcul dinamic de marja per Client si Produs cu filtre interactive.',
      icon: TrendingUp,
      color: 'cyan',
      link: '/reports/margin-analysis'
    },
    {
      id: 'tops-analysis',
      title: "TOP's Analysis",
      desc: 'Top-uri centralizate si comparatii intre perioade.',
      icon: TrendingUp,
      color: 'green',
      link: '/reports/tops-analysis'
    }
  ];

  return (
    <div className="p-8 pb-40">
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-white mb-2">Rapoarte Disponibile</h1>
        <p className="text-gray-400">Selecteaza un raport pentru a incarca datele.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reports.map((r) => (
          <Link key={r.id} to={r.link}>
            <Card className="bg-[#18181b] border-white/10 hover:border-cyan-500/50 transition-all cursor-pointer group h-full">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-lg font-semibold text-white group-hover:text-cyan-400 transition-colors">
                  {r.title}
                </CardTitle>
                <r.icon className={`text-${r.color}-400`} size={20} />
              </CardHeader>
              <CardContent>
                <p className="text-sm text-gray-400 mb-4">{r.desc}</p>
                <Badge variant="outline" className="border-white/20 text-xs">
                  Standard
                </Badge>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>

      {/* New Categories Row */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          {
            title: 'Clienti',
            desc: 'Toate rapoartele despre Clientii',
            icon: Users,
            color: 'blue',
            link: '/reports/clients'
          },
          {
            title: 'Agenti',
            desc: 'Toate rapoartele despre Agentii',
            icon: Briefcase,
            color: 'purple',
            link: '/reports/agents'
          },
          {
            title: 'Furnizori',
            desc: 'Toate rapoartele despre Furnizorii',
            icon: Truck,
            color: 'orange',
            link: '/reports/suppliers'
          },
          {
            title: 'Avicarvil',
            desc: 'Clienti Avicarvil',
            icon: Building,
            color: 'red',
            link: '/reports/avicarvil'
          }
        ].map((item, idx) => (
          <Link key={idx} to={item.link}>
            <Card className="bg-[#18181b] border-white/10 hover:border-cyan-500/50 transition-all cursor-pointer group h-full">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-lg font-semibold text-white group-hover:text-cyan-400 transition-colors">
                  {item.title}
                </CardTitle>
                <item.icon className={`text-${item.color}-400`} size={20} />
              </CardHeader>
              <CardContent>
                <p className="text-sm text-gray-400 mb-4">{item.desc}</p>
                <Badge variant="outline" className="border-white/20 text-xs">
                  Categorie
                </Badge>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}